// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addCompetitor label {
  margin-top: 10px;
}
.accom-image{
  width:100px;
  height:100px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.MuiModal-root:focus {
  background-color: white !important;
}

.modal-org-title {
  font-size: 24px;
  font-weight: 400;
  color: #323232;
  margin: 30px 0;
}
.modal-org-subtitle {
  font-size: 16px;
  color: #323232;
}
.org-modal-div {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  height: auto;
  width: 421px;
  border-radius: 4px !important;
}
.add-comp-error{
  width: 245px;
}
.org-modal-div:focus-visible {
  outline: none !important;
}
.org-modal-url:focus-visible {
  outline: none !important;
}

.org-modal-url {
  display: flex;
  background-color: #ffffff;
  height: auto;
  width: 421px;
  border-radius: 4px !important;
}
.modal-select {
  padding-left: 8px;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 12px 7px !important;
  background-repeat: no-repeat;
  background-size: 4%;
  background-position: top 50% right 4%;
  outline: none;
  width: 248px;
  border: 1px solid #797979;
  border-radius: 4px;
  height: 40px;
}
.modal-input {
  padding-left: 8px;
  outline: none;
  width: 248px;
  border: 1px solid #797979;
  border-radius: 4px;
  height: 40px;
}
.custom-dropdown {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: scroll !important;
  z-index: 1;
}
.custom-dropdown-options {
  padding-left: 8px;
}
.custom-dropdown-options:hover {
  color: white;
  background: #0d6efd;
  cursor: pointer;
}

.added-comp {
  padding: 20px 100px 50px 100px;
}
.split-input {
  width: 431px;
  height: 40px;
  border: 1px solid #797979;
  border-radius: 4px;
  padding-left: 10px;
  outline: none;
}
.merge-modal-div {
  width: auto !important;
  padding: 0px 40px 40px 40px !important;
}
.split-form-div {
  width: 421px;
}
.split-subtitle {
  padding: 0 50px;
  text-align: center;
}
.urlInput,
.urlInput:focus {
  -webkit-appearance: none;
  outline: none;
  border: none;
  width: 250px;
}
.copyUrlDiv {
  border: 1px solid black;
  border-radius: 4px;
  display: flex;
  padding: 10px;
  width: 300px;
  justify-content: space-between;
}
.urlInput:disabled {
  background-color: transparent;
}

@media only screen and (min-width: 0px) and (max-width: 480px) {
  .org-modal-div {
    width: 300px;
  }
  .added-comp {
    padding: 20px 0px 50px 0px;
  }
  .split-input {
    width: 250px;
  }
  .merge-modal-div {
    width: auto !important;
    padding: 0px 20px 40px 20px !important;
  }
  .modal-org-title {
    font-size: 18px;
  }
  .modal-org-subtitle {
    font-size: 12px;
  }
  .split-form-div {
    width: 260x;
  }
  .urlInput,
  .urlInput:focus {
    width: 200px;
  }

  .copyUrlDiv {
    width: 250px;
  }
}
@media only screen and (min-width: 481px) and (max-width: 767px) {
  .split-input {
    width: 250px;
  }
}
@media only screen and (min-width: 768px) {
  .split-modal-div {
    width: 500px !important;
  }
}

/* control */
.react-select > div  > div:nth-child(3){
  box-shadow: none !important;
  border-color: rgb(98, 101, 98) !important;
  width: 248px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 12px;
  background-position: top 50% right 4%;
}

/* Indicators Container */
.react-select > div  > div > div:nth-child(2) {
  display:none !important;
}

/* value Container */
.react-select > div  > div:nth-child(3) > div:nth-child(1) {
  max-width:235px !important;
}
.react-select > div  > div:nth-child(3) > div:nth-child(1)>div >div:nth-child(2):hover {
  background-color:hsl(0, 0%, 85%) !important;
  color:black;
}

.react-select > div  > div:nth-child(4){
overflow:scroll !important;
}

`, "",{"version":3,"sources":["webpack://./src/Components/Modals/OrganizerModel/ManageFeis/ManageFeis.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yDAA2D;EAC3D,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,sCAAsC;EACxC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,uBAAuB;EACvB,yDAA2D;EAC3D,4BAA4B;EAC5B,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;AAC5B;AACA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;AACA,0BAA0B;AAC1B","sourcesContent":[".addCompetitor label {\n  margin-top: 10px;\n}\n.accom-image{\n  width:100px;\n  height:100px;\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n.MuiModal-root:focus {\n  background-color: white !important;\n}\n\n.modal-org-title {\n  font-size: 24px;\n  font-weight: 400;\n  color: #323232;\n  margin: 30px 0;\n}\n.modal-org-subtitle {\n  font-size: 16px;\n  color: #323232;\n}\n.org-modal-div {\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  height: auto;\n  width: 421px;\n  border-radius: 4px !important;\n}\n.add-comp-error{\n  width: 245px;\n}\n.org-modal-div:focus-visible {\n  outline: none !important;\n}\n.org-modal-url:focus-visible {\n  outline: none !important;\n}\n\n.org-modal-url {\n  display: flex;\n  background-color: #ffffff;\n  height: auto;\n  width: 421px;\n  border-radius: 4px !important;\n}\n.modal-select {\n  padding-left: 8px;\n  -webkit-appearance: none;\n  background-image: url('../../../../Assets/selectArrow.png');\n  background-size: 12px 7px !important;\n  background-repeat: no-repeat;\n  background-size: 4%;\n  background-position: top 50% right 4%;\n  outline: none;\n  width: 248px;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  height: 40px;\n}\n.modal-input {\n  padding-left: 8px;\n  outline: none;\n  width: 248px;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  height: 40px;\n}\n.custom-dropdown {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  max-height: 150px;\n  overflow-y: scroll !important;\n  z-index: 1;\n}\n.custom-dropdown-options {\n  padding-left: 8px;\n}\n.custom-dropdown-options:hover {\n  color: white;\n  background: #0d6efd;\n  cursor: pointer;\n}\n\n.added-comp {\n  padding: 20px 100px 50px 100px;\n}\n.split-input {\n  width: 431px;\n  height: 40px;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  padding-left: 10px;\n  outline: none;\n}\n.merge-modal-div {\n  width: auto !important;\n  padding: 0px 40px 40px 40px !important;\n}\n.split-form-div {\n  width: 421px;\n}\n.split-subtitle {\n  padding: 0 50px;\n  text-align: center;\n}\n.urlInput,\n.urlInput:focus {\n  -webkit-appearance: none;\n  outline: none;\n  border: none;\n  width: 250px;\n}\n.copyUrlDiv {\n  border: 1px solid black;\n  border-radius: 4px;\n  display: flex;\n  padding: 10px;\n  width: 300px;\n  justify-content: space-between;\n}\n.urlInput:disabled {\n  background-color: transparent;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n  .org-modal-div {\n    width: 300px;\n  }\n  .added-comp {\n    padding: 20px 0px 50px 0px;\n  }\n  .split-input {\n    width: 250px;\n  }\n  .merge-modal-div {\n    width: auto !important;\n    padding: 0px 20px 40px 20px !important;\n  }\n  .modal-org-title {\n    font-size: 18px;\n  }\n  .modal-org-subtitle {\n    font-size: 12px;\n  }\n  .split-form-div {\n    width: 260x;\n  }\n  .urlInput,\n  .urlInput:focus {\n    width: 200px;\n  }\n\n  .copyUrlDiv {\n    width: 250px;\n  }\n}\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n  .split-input {\n    width: 250px;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .split-modal-div {\n    width: 500px !important;\n  }\n}\n\n/* control */\n.react-select > div  > div:nth-child(3){\n  box-shadow: none !important;\n  border-color: rgb(98, 101, 98) !important;\n  width: 248px !important;\n  background-image: url('../../../../Assets/selectArrow.png');\n  background-repeat: no-repeat;\n  background-size: 12px;\n  background-position: top 50% right 4%;\n}\n\n/* Indicators Container */\n.react-select > div  > div > div:nth-child(2) {\n  display:none !important;\n}\n\n/* value Container */\n.react-select > div  > div:nth-child(3) > div:nth-child(1) {\n  max-width:235px !important;\n}\n.react-select > div  > div:nth-child(3) > div:nth-child(1)>div >div:nth-child(2):hover {\n  background-color:hsl(0, 0%, 85%) !important;\n  color:black;\n}\n\n.react-select > div  > div:nth-child(4){\noverflow:scroll !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
